import React from "react";

/** hooks */
import { useAuth } from "@hooks/useAuth";
import { useSeenVersion } from "@hooks/useSeenVersion";

import useTheme from "@styles/useTheme";
import useTranslation from "@languages/useTranslation";
import { CustomerMessages } from "@languages/interfaces";

import SidebarDrawerMenu from "@atoms/SidebarDrawerMenu";
import { useSidebarMenu } from "@hooks/menuItensContext";

const SidebarDrawerMenus: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { user } = useAuth();
  const { menuItems } = useSidebarMenu();
  const { unseen } = useSeenVersion(user?.email);

  return (
    <>
      { menuItems.map(({ id, title, icon, link, onlyAdmin, hidden }) => {

        if (onlyAdmin && !user.admin) return null;
        if (!user.admin && hidden) return null;

        return (
          <SidebarDrawerMenu
            key={`${id}_${title}`}
            id={id}
            title={t(title)}
            icon={icon}
            link={link}
            secondaryColor={theme.colors.secondary}
            identifierColor={theme.colors.tertiary}
            type="primary"
            badge={link === "/docs" && unseen ? t(CustomerMessages.newBadge) : undefined}
          />
        );
      })}
    </>
  );
};

export default React.memo(SidebarDrawerMenus);
